const CANCEL_DROP_MODAL_CLOSE_COMPONENT_PROPS = {
  'data-testid': 'cancel-drop-modal-close',
  'icon': 'icon_symbols_close-thick',
  'width': '24px',
  'height': '24px',
};

export { CANCEL_DROP_MODAL_CLOSE_COMPONENT_PROPS };
